import * as CryptoJS from "crypto-js";

const NEW_KEY =
  "https://test-1301875615.cos.ap-beijing.myqcloud.com/images/2022031203413046507WhatsApp%20Image%202022-03-12%20at%2003.40.51.jpeg";
const IV = "ADKOPSTF%2003.40";
const KEY_PREFIX = "ADKOPSTF" + NEW_KEY.slice(-16);

// 判断的是否是JSON字符串
export const isJSON = (str) => {
  if (typeof str == "string") {
    try {
      var obj = JSON.parse(str);
      // 等于这个条件说明就是JSON字符串 会返回true
      if (typeof obj == "object" || typeof obj == "string") {
        return true;
      } else {
        //不是就返回false
        return false;
      }
    } catch (e) {
      return false;
    }
  }
  return false;
};

/** 从密文末尾提取时间戳十六进制（与加密时拼上的 timestamp16 对应） */
function takeTimestamp16(encryptedStr) {
  // 秒级时间戳转 16 进制一般为 8 位大写；兼容 7 位历史值
  const match = /([0-9A-Fa-f]{7,8})$/.exec(encryptedStr);
  const timestamp16 = (match?.[1] ?? encryptedStr.slice(-8)).toUpperCase();
  return {
    timestamp16,
    body: encryptedStr.slice(0, -timestamp16.length),
  };
}

/** AES 解密：与 aesEncode 对称，用密文末尾 timestamp16 还原 key（对齐 chat-mgmt） */
export const aesDecode = (encryptedStr) => {
  if (!encryptedStr || typeof encryptedStr !== "string") {
    return encryptedStr;
  }

  try {
    const { timestamp16, body } = takeTimestamp16(encryptedStr);
    if (!body) return encryptedStr;

    const decodedStr = decodeURIComponent(body);
    const key = KEY_PREFIX + timestamp16;
    const decryptedBytes = CryptoJS.AES.decrypt(decodedStr, CryptoJS.enc.Utf8.parse(key), {
      iv: CryptoJS.enc.Utf8.parse(IV),
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    });
    const res = decryptedBytes.toString(CryptoJS.enc.Utf8).trim();
    // 空字符串加密后仍有密文；解密成功但明文为空时应返回空，避免把密文当文案展示
    if (!res) return "";

    if (isJSON(res)) {
      return JSON.parse(res);
    }
    return res;
  } catch {
    return encryptedStr;
  }
};

/** AES 加密：key = ADKOPSTF + newKey末16位 + 秒级时间戳十六进制 */
export const aesEncode = (data) => {
  const text = typeof data === "string" ? data : "";

  try {
    const timestampInSeconds = Math.floor(Date.now() / 1000);
    const timestamp16 = timestampInSeconds.toString(16).toUpperCase();
    const key = KEY_PREFIX + timestamp16;
    const dataHex = CryptoJS.enc.Utf8.parse(text);
    const keyHex = CryptoJS.enc.Utf8.parse(key);
    const ivHex = CryptoJS.enc.Utf8.parse(IV);
    const encrypted = CryptoJS.AES.encrypt(dataHex, keyHex, {
      iv: ivHex,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    });
    return encodeURIComponent(encrypted.toString()) + timestamp16;
  } catch (error) {
    console.error("AES encode error:", error);
    return text;
  }
};
